module.exports = __webpack_public_path__ + "img/liver.356db05b.png";